import React from "react";
import { Box, Typography, Divider } from "@mui/material";

export default function ReportPrintHeader({ title, subTitle, dateRange, company }) {
  // Use passed company prop or fallback to localStorage/Defaults
  const companyData = company || {
    name: localStorage.getItem("companyName") || "اسم الشركة الافتراضي",
    nameEn: localStorage.getItem("companyNameEn") || "Default Company Name",
    taxNumber: localStorage.getItem("companyTaxNumber") || "300000000000003",
    address: localStorage.getItem("companyAddress") || "الرياض - المملكة العربية السعودية",
    addressEn: localStorage.getItem("companyAddressEn") || "Riyadh - KSA",
    phone: localStorage.getItem("companyPhone") || "0500000000",
    email: localStorage.getItem("companyEmail") || "info@example.com",
    logoUrl: localStorage.getItem("companyLogo") || "/logo.png"
  };

  return (
    <Box sx={{ width: "100%", direction: "rtl", mb: 2 }} className="report-header-container">
      {/* 1. Company Header (From Invoice Design) */}
      <div style={{ marginBottom: "25px", width: "100%", direction: "rtl" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr auto 1fr", // 3 columns: Arabic - Logo - English
            alignItems: "center",
            gap: "20px",
            width: "100%",
            direction: "rtl"
          }}
        >
          {/* Right (Arabic) */}
          <div style={{ textAlign: "right", fontSize: "14px", direction: "rtl" }}>
            <div style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "4px" }}>
              {companyData.name}
            </div>
            <div>الرقم الضريبي: {companyData.taxNumber || "—"}</div>
            <div>العنوان: {companyData.address || "—"}</div>
            <div>الهاتف: {companyData.phone || "—"}</div>
          </div>

          {/* Center (Logo) */}
          <div style={{ textAlign: "center", minWidth: "100px" }}>
            {companyData.logoUrl && (
              <img
                src={companyData.logoUrl}
                alt="Company Logo"
                style={{
                  maxWidth: "120px",
                  maxHeight: "100px",
                  objectFit: "contain",
                }}
                onError={(e) => (e.target.style.display = "none")}
              />
            )}
          </div>

          {/* Left (English) */}
          <div style={{ textAlign: "left", fontSize: "14px", direction: "ltr" }}>
            <div style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "4px" }}>
              {companyData.nameEn || companyData.name}
            </div>
            <div>VAT No: {companyData.taxNumber || "—"}</div>
            <div>Address: {companyData.addressEn || companyData.address || "—"}</div>
            <div>Phone: {companyData.phone || "—"}</div>
          </div>
        </div>
      </div>

      <Divider sx={{ mb: 2, borderColor: "#000", borderBottomWidth: 2 }} />

      {/* 2. Report Title Section */}
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <Typography variant="h4" fontWeight="bold" sx={{ textDecoration: "underline", mb: 1 }}>
          {title}
        </Typography>
        {subTitle && (
          <Typography variant="h6" fontWeight="bold" color="text.primary" dir="rtl">
            {subTitle}
          </Typography>
        )}
        {dateRange && (
          <Typography variant="subtitle1" sx={{ mt: 1, fontWeight: "bold" }}>
            {dateRange}
          </Typography>
        )}
      </Box>
      
      {/* 3. Footer (Fixed at bottom via CSS in print media if needed, or just at end of flow) */}
      {/* Note: In ReactToPrint, fixed positioning at bottom of page is tricky without specific CSS. 
          We will add a footer section here that appears at the top of the content for reference, 
          OR strictly rely on the page layout. 
          For now, let's keep the print metadata (User/Date) here.
      */}
      <Box sx={{ display: "flex", justifyContent: "space-between", fontSize: "0.8rem", color: "#555", mb: 2 }}>
         <span>تاريخ الطباعة: {new Date().toLocaleString("en-GB")}</span>
         <span>المستخدم: {localStorage.getItem("username") || "Admin"}</span>
      </Box>

      {/* Fixed Footer Style Injection */}
      <style>{`
        @media print {
          .report-footer {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            text-align: center;
            font-size: 11px;
            color: #777;
            border-top: 1px solid #ddd;
            padding-top: 4px;
            background: white;
          }
        }
      `}</style>
    </Box>
  );
}
